var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dui-expandable-options"},_vm._l((_vm.availableOptions),function(option,index){return _c('DuiExpandableOption',{key:index,attrs:{"option":option},on:{"option-selected":_vm.optionSelected}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }